import type { IInjectorModule } from '@paperbits/common/injection';

import { ContinuousSliderHTMLElement } from './continuousSlider-runtime';

export class ContinuousSliderRuntimeModule implements IInjectorModule {
    public register(): void {
        customElements.define('continuous-slider-runtime', ContinuousSliderHTMLElement);
    }
}
